import React from 'react';

import CheckBox from '../../Basic/CheckBox';

export default p => {
  return (
    <div>
      {p.lookup.chosenWeek}
      <h4>{p.dateSelected}</h4>
      {p.lookup.chosenWeekNote}
      <CheckBox name="isCustomerSpecifiedDate" title={p.lookup.customerSpecifiedDate} display={p.dateSelected ? false : true} />
      {p.error ? <label className="control-label has-error validationMessage">{p.error}</label> : null}
    </div>
  );
};
